export default __webpack_public_path__ + "static/media/bedding.532582c8.png";